import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { NavigationStart, Router, RouterLink, RouterModule } from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ReplaySubject, takeUntil } from 'rxjs';
import { RepairLocationSearchComponent } from '../../components/repair-location/repair-location-search/repair-location-search.component';
import { RepairLocationFiltersComponent } from '../../components/repair-location/repair-location-filters/repair-location-filters.component';
import { RepairLocationGridComponent } from '../../components/repair-location/repair-location-grid/repair-location-grid.component';
import { RepairLocationFilterForm } from '../../form-model/repair-location-filter.form.model';
import { RepairLocationSearchTextForm } from '../../form-model/repair-location-search-text.form.model';
import { RepairLocationService } from '../../services/repair-location.service';

@Component({
  selector: 'app-repair-location-list',
  templateUrl: './repair-location.component.html',
  styleUrl: './repair-location.component.scss',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterLink,
    RouterModule,
    NgxSkeletonLoaderModule,
    RepairLocationSearchComponent,
    RepairLocationFiltersComponent,
    RepairLocationGridComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RepairLocationListComponent implements OnInit, OnDestroy {
  filterFormGroup = this.formBuilder.group({
    repairLocationFilterForm: this.formBuilder.group<RepairLocationFilterForm>({} as RepairLocationFilterForm),
    repairLocationSearchTextForm: this.formBuilder.group<RepairLocationSearchTextForm>({} as RepairLocationSearchTextForm),
  });

  private readonly destroyed$ = new ReplaySubject<boolean>(1);

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly repairLocationService: RepairLocationService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(takeUntil(this.destroyed$)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (!event.url.startsWith('/master-data/repair-location')) {
          this.repairLocationService.setRepairLocationFilterFormValue(null);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
